export const NAVIGATE_TO_URL = 'ExternalUriInterface.v1_0.NavigateToExternalUriMethod';
export const DOWNLOAD_FROM_URL = 'ExternalUriInterface.v1_0.DownloadFromExternalUriMethod';
export const NAVIGATE_TO_DEEPLINK = 'DeeplinkInterface.v1_0.NavigateToDeeplinkMethod';
export const CLOSE_CURRENT_TAB_METHOD = 'Web.PageInterface.v1_0.CloseCurrentTabMethod';
